<template>
  <span v-if="signatory" :class="list ? 'd-block ml-2 my-0' : 'd-inline-flex align-center'">
    <slot name="prepend" />
    <slot name="item" :item="signatory">
      {{ signatoryLabel(signatory) }}
    </slot>
    <v-tooltip v-if="!hideIcon" top>
      <span>{{ $t('vorstossSignatorySigned') }}</span>
      <template #activator="{ on, attrs }">
        <v-icon v-if="signed" v-bind="attrs" small color="blue" class="ml-1" v-on="on">mdi-check-decagram</v-icon>
      </template>
    </v-tooltip>
    <slot name="append" />
  </span>
</template>

<script>
import isUndefined from 'lodash/isUndefined'

export default {
  name: 'VorstossSignatory',
  props: {
    signatory: {
      type: [Object, String],
      default: null,
    },
    hideIcon: {
      type: Boolean,
      default: false,
    },
    hasSigned: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    signed() {
      return this.hasSigned || this.signatory.is_signed
    },
  },
  methods: {
    signatoryLabel(signatory) {
      if (isUndefined(signatory)) return ''
      if (typeof signatory === 'string') return signatory
      if (signatory.type === 'user') return signatory.full_name
      if (signatory.type === 'committee' || signatory.type === 'committeegroup') return signatory.title || ''
      return ''
    },
  },
}
</script>
